import { PropsWithChildren } from "react";
import { StudentFormData, useStudentForm } from "../StudentDataFormProvider";
import { Stack, styled, Typography } from "@mui/material";

type Props = {
  fieldName: keyof StudentFormData;
  label?: string;
  maxLength?: number;
  required?: boolean;
};

export const ShortTextField = ({
  fieldName,
  label,
  maxLength = 100,
  required = false,
}: PropsWithChildren<Props>) => {
  const {
    register,
    formState: { errors },
  } = useStudentForm();
  return (
    <Stack gap={"0.25rem"} width={"100%"}>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <StyledInput type="text" {...register(fieldName, { required, maxLength })}></StyledInput>
      {errors[fieldName] && (
        <Typography variant="caption" sx={{ color: "red" }}>
          This field is required
        </Typography>
      )}
    </Stack>
  );
};

const StyledInput = styled("input")({
  borderRadius: "0.5rem",
  padding: "0.5rem",
  fontSize: "1rem",
  border: "1px solid #cbcbcb",
});
